import styled from 'styled-components';

export const Wrap = styled.div`
  padding: 4%;
`;

export const InfoText = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 24px;

  > span {
    &.bold {
      font-weight: 700;
    }

    &.value {
      font-size: 12px;
      max-width: 40%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  & + & {
    margin-top: 4px;
  }
`;

export const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;

  > button {
    width: 100%;
    padding: 24px;
    border: 1px solid #bbb;
    border-radius: 2px;
    font-size: 20px;
    font-weight: 700;

    & + button {
      margin-top: 12px;
    }
  }
`;
